import type { LucideIcon } from 'lucide-react';
import { IconWrapper } from '@/components/ui/atoms/IconWrapper';
import { cn } from '@/utils/cn';

/** Soft purple square chrome; IconWrapper sizes the glyph only. */
export const OverviewIconBadge = ({
  icon: Icon,
  size = 'sm',
  className,
}: {
  icon: LucideIcon;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) => (
  <span
    className={cn(
      'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-purple-soft/40',
      className,
    )}
  >
    <IconWrapper size={size} color="purple" ariaHidden>
      <Icon />
    </IconWrapper>
  </span>
);
